import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Card,
  Typography,
  Modal,
  ModalDialog,
  ModalClose,
  DialogTitle,
  Stack,
} from "@mui/joy";
import { CardContent, DialogContent } from "@mui/material";
import { useLocation } from "react-router-dom";
import { LoadingView, PageTitle } from "../../../components";
import DescriptionIcon from "@mui/icons-material/Description";
import { connect, useDispatch } from "react-redux";
import {
  listFolderLogsRequest,
  listFolderLogsReset,
} from "../../../store/actions";
import { STATUS } from "../../../constant";
import { toast } from "react-toastify";
import ViewLog from "./ViewLog";

const ListFolderLogs = ({
  otpResult,
  listFolderLogsStatus,
  listFolderLogsMessage,
  listFolderLogsResult,
}) => {
  const dispatch = useDispatch();
  const token = otpResult?.token;
  const location = useLocation();
  const { folder_type, folder_name } = location.state || {};
  const [logModal, setLogModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  useEffect(() => {
    const data = {
      folder_type: folder_type,
      folder_name: folder_name,
    };
    dispatch(listFolderLogsRequest(token, data));
  }, []);

  useEffect(() => {
    if (listFolderLogsStatus === STATUS.ERROR) {
      toast.error(listFolderLogsMessage, {
        toastId: "listFolderLogsError",
      });
      dispatch(listFolderLogsReset());
    }
  }, [dispatch, listFolderLogsMessage, listFolderLogsStatus]);

  const files = listFolderLogsResult?.files || [];

  return (
    <>
      <LoadingView loading={listFolderLogsStatus === STATUS.LOADING} />
      <Box>
        <PageTitle
          title={`${folder_type?.replace(/_/g, " ")} - ${folder_name}`}
        />

        <Grid
          container
          spacing={{ xs: 1, md: 2 }}
          columns={{ xs: 10, sm: 10, md: 10 }}
          sx={{ flexGrow: 1, mt: 1 }}
        >
          {files.map((file, index) => (
            <Grid xs={2} sm={2} md={2} key={index}>
              <Card
                variant="soft"
                onClick={() => {
                  setLogModal(true);
                  setSelectedFile(file);
                }}
                sx={{
                  backgroundColor: "background.popup",
                  boxShadow: "sm",
                  p: 0,
                  cursor: "pointer",
                  minHeight: "80px",
                }}
              >
                <CardContent>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Card
                      variant="soft"
                      sx={{
                        backgroundColor: "#e3f2fd",
                        width: "45px",
                        height: "45px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "8px",
                      }}
                    >
                      <DescriptionIcon
                        sx={{
                          color: "#1976d2",
                          fontSize: "22px",
                        }}
                      />
                    </Card>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                      }}
                    >
                      <Typography level="body-sm" sx={{ fontSize: "13px" }}>
                        {file}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Modal open={logModal}>
          <ModalDialog
            aria-labelledby="nested-modal-title"
            aria-describedby="nested-modal-description"
            sx={(theme) => ({
              maxWidth: 600,
              width: "90%",
              [theme.breakpoints.only("xs")]: {
                bottom: 0,
                left: 0,
                right: 0,
                borderTopLeftRadius: 20,
                borderTopRightRadius: 20,
                transform: "none",
                maxWidth: "unset",
                overflowY: "auto",
                overflowX: "hidden",
                wordBreak: "break-word",
                whiteSpace: "normal",
              },
            })}
          >
            <ModalClose variant="outlined" onClick={() => setLogModal(false)} />
            <DialogTitle>{`View Log: ${selectedFile}`}</DialogTitle>
            <DialogContent>
              {`this is the content of the log ${selectedFile}`}
            </DialogContent>
            <Stack component={"div"} sx={{ mt: 2 }}>
              <ViewLog
                selectedLog={{
                  folder_type,
                  folder_name,
                  file_name: selectedFile,
                }}
                logModal={logModal}
              />
            </Stack>
          </ModalDialog>
        </Modal>
      </Box>
    </>
  );
};

const mapStateToProps = ({ auth, logs }) => {
  const { otpResult } = auth;
  const { listFolderLogsStatus, listFolderLogsMessage, listFolderLogsResult } =
    logs;

  return {
    otpResult,
    listFolderLogsStatus,
    listFolderLogsMessage,
    listFolderLogsResult,
  };
};

export default connect(mapStateToProps, {})(ListFolderLogs);
